import type { vendorApiNames } from '../names';
import type { BaseUpdateVendorApiSettings, BaseVendorApi } from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

export interface VendorAzureAuthentication {
  clientId: string;
  clientSecret: string;
}

export interface AzureConnectionSettings {
  tenantId: string;
  subscriptionIds?: string[];
  /**
   * Default retry after value in milliseconds when the Azure server sends 202 http response with no Retry-After value.
   */
  default202DataRetryAfterMs?: number;
}

/**
 * Azure API settings available from API
 */
export type PublicAzureApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['azure']
> &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings &
  AzureConnectionSettings;

/**
 * Azure API settings available in backend
 */
export type AzureApiSettings = PublicAzureApiSettings &
  VendorAzureAuthentication;

/**
 * Azure API settings expected on API when updating
 */
export type UpdateAzureApiSettings = BaseUpdateVendorApiSettings<
  PublicAzureApiSettings,
  VendorAzureAuthentication
>;
